import { all, fork, put, select, takeEvery  } from "redux-saga/effects";
import { GeneralActionTypes, SignalRTypes } from "../actions";
export function* requests() {
  yield takeEvery(SignalRTypes.On_Current_Banner_Response, function*({
    response,
  }) {
    try {
      window.console.response("RES On_Current_Banner_Response=>", response);
     
      switch (response.status) {
        case 1:
          let currentBanner = response.data && response.data.bannersChanges && response.data.bannersChanges[0]
          yield put({
            type: SignalRTypes.Get_Current_Banner_Success,
            currentKioskBanner: currentBanner,
          });

          break;
      }
    } catch (e) {
      window.log("ERROR", e);
    }
  });
  yield takeEvery(SignalRTypes.On_Banner_Change, function*({
    response,
  }) {
    try {
      window.console.response("RES On_Banner_Change=>", response[0]);
     
      if (response) {
          let currentBanner = response[0]
          console.log("currentBannercurrentBanner",currentBanner);
          yield put({
            type: SignalRTypes.On_Banner_Change_Success,
            currentKioskBanner: currentBanner,
          });
      }
    } catch (e) {
      window.log("ERROR", e);
    }
  });
  yield takeEvery(SignalRTypes.On_Configration_Change, function*({
    response,
  }) {
    try {
      window.console.response("RES On_Configration_Change=>", response);
      yield put({
        type: GeneralActionTypes.Get_Kiosk_Web_Banner_Images_Request,
        GroupId: window.location.pathname.split("/")[ window.location.pathname.split("/").length -1],
      });
    } catch (e) {
      window.log("ERROR", e);
    }
  });
//   yield takeEvery(
//     SignalRTypes.Get_Draws_Categories_And_Tournaments_Response,
//     function*({ response }) {
//       try {
//         window.console.response(
//           "RES onDrawsCategoriesAndTournaments=>",
//           response
//         );

//         switch (response.status) {
//           case 1:
//             yield put({
//               type: SignalRTypes.Get_Draws_Categories_And_Tournaments_Success,
//               drawsCategories: response.data && response.data,
//             });

//             break;

//           case 3:
//             yield put({
//               type: SignalRTypes.Get_Draws_Categories_And_Tournaments_Error,
//               error: response.message,
//             });
//             break;
//         }
//       } catch (e) {
//         window.log("ERROR", e);
//       }
//     }
//   );

}
export default function* KioskBannerSaga() {
  yield all([fork(requests)]);
}
